import {
	ChangeDetectionStrategy,
	Component,
	inject,
	OnInit,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import { MatterFileType } from '@models/matter';
import { MatterMortgageWithAssociations } from '@models/mortgage';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { VirtualizedMatterFile } from '@state/global/uploaded-documents/upload-documents';
import { SelectedMatter } from '@state/matter/matter.selectors';
import {
	MatterMortgageDispatch,
	MatterMortgagesState,
} from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-closer-sync-mortgage-details',
	templateUrl: './closer-sync-mortgage-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncMortgageDetailsComponent implements OnInit {
	@ViewSelectSnapshot(SelectedMatter.matterFileType)
	matterFileType: MatterFileType;
	@Select(MatterMortgagesState.getSelectedMortgage)
	mortgage$: Observable<MatterMortgageWithAssociations>;

	public _mortgage: MatterMortgageWithAssociations;
	public ICON = ICON;
	public uploadedDocs: VirtualizedMatterFile[] = [];

	private mortgageDispatch = inject(MatterMortgageDispatch);

	ngOnInit(): void {
		this.mortgage$.subscribe((mortgage) => {
			this._mortgage = mortgage;
		});
	}

	setCommitmentDate(date: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			commitmentDate: date,
		});
	}

	setAssignmentOfRents(value: boolean): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			assignmentOfRents: value,
		});
	}

	setGeneralSecurityAgreement(value: boolean): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			generalSecurityAgreement: value,
		});
	}

	updateRegistrationDate($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			registrationDate: $event,
		});
	}

	updateGeneralSecurityAgreementRegDate($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			generalSecurityAgreementRegDate: $event,
		});
	}

	updateRegistrationNumber($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			registrationNumber: $event,
		});
	}

	updateAdditionalClauses($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			additionClauses: $event,
		});
	}

	updateSigningDate($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			signingDate: $event,
		});
	}

	updateGeneralSecurityAgreementRegNumber($event: string): void {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			generalSecurityAgreementRegNumber: $event,
		});
	}
}
